// find elem in focus --DEBUGGER
(function () {
  document.addEventListener('focusin', function (e) {
    var el = e.target;
    try {
      console.log('[a11y tab]', el, {
        tag: el && el.tagName ? el.tagName.toLowerCase() : null,
        id: el && el.id ? el.id : null,
        class: el && typeof el.className === 'string' ? el.className : null,
        name: el && el.getAttribute ? (el.getAttribute('name') || null) : null,
        role: el && el.getAttribute ? (el.getAttribute('role') || null) : null,
        ariaLabel: el && el.getAttribute ? (el.getAttribute('aria-label') || null) : null,
        tabindex: el && el.getAttribute ? (el.getAttribute('tabindex') || null) : null
      });
    } catch (err) {
      console.log('[a11y tab] focusin, but logging failed', err);
    }
  }, true);

  console.log('[a11y tab] focus logger installed. Press Tab now.');
})();


// SKIP LINK, FOCUS H1 
(function initSkipToContentFocus() {
  const skipLink = document.querySelector('a.skip-link-v2[href="#MainContent"]');
  if (!skipLink) return;

  skipLink.addEventListener('click', (e) => {
    e.preventDefault();

    const main = document.getElementById('MainContent');
    if (!main) return;

    const h1 = main.querySelector('h1');

    const focusTarget = h1 || main;

    if (!focusTarget.hasAttribute('tabindex')) {
      focusTarget.setAttribute('tabindex', '-1');
    }

    focusTarget.focus({ preventScroll: true });
    focusTarget.scrollIntoView({ block: 'start' });

    if (focusTarget !== main) {
      setTimeout(() => {
        focusTarget.removeAttribute('tabindex');
      }, 0);
    }
  });
})();


/**** COLLECTION FILTER MENU ****/
(function () {
  function initCollectionFilterMenuA11y() {
    var filterTrigger = document.getElementById('filter-trigger');
    var filterMenu = document.getElementById('filter-menu');

    if (!filterTrigger || !filterMenu) return;
    if (filterTrigger.dataset.a11yFilterBound === 'true') return;

    filterTrigger.setAttribute('aria-haspopup', 'dialog');
    filterTrigger.setAttribute('aria-expanded', 'false');
    filterTrigger.setAttribute('aria-controls', 'filter-menu');

    filterMenu.setAttribute('role', 'dialog');
    filterMenu.setAttribute('aria-modal', 'true');
    filterMenu.setAttribute('aria-label', 'Filter');

    function isMenuOpen() {
      return filterMenu.style.display === 'flex';
    }

    function syncExpandedState() {
      filterTrigger.setAttribute('aria-expanded', isMenuOpen() ? 'true' : 'false');
    }

    function getFocusableInMenu() {
      return Array.from(
        filterMenu.querySelectorAll(
          'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        )
      ).filter(function (el) {
        return !el.hasAttribute('disabled') && el.offsetParent !== null;
      });
    }

    function focusFirstInMenu() {
      var focusable = getFocusableInMenu();
      if (focusable.length) {
        focusable[0].focus();
      }
    }

    function returnFocusToTrigger() {
      filterTrigger.focus();
    }

    filterTrigger.addEventListener('click', function () {
      requestAnimationFrame(function () {
        syncExpandedState();
        if (isMenuOpen()) {
          focusFirstInMenu();
        }
      });
    });

    document.addEventListener('click', function () {
      requestAnimationFrame(syncExpandedState);
    });

    document.addEventListener('keydown', function (event) {
      if (!isMenuOpen()) return;

      if (event.key === 'Escape') {
        requestAnimationFrame(function () {
          syncExpandedState();
          returnFocusToTrigger();
        });
        return;
      }

      if (event.key === 'Tab') {
        var focusable = getFocusableInMenu();
        if (!focusable.length) return;

        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    var closeBtn = document.getElementById('filter-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        requestAnimationFrame(function () {
          syncExpandedState();
          returnFocusToTrigger();
        });
      });
    }

    syncExpandedState();
    filterTrigger.dataset.a11yFilterBound = 'true';
  }

  function waitForCollectionFilterMenu() {
    initCollectionFilterMenuA11y();

    var observer = new MutationObserver(function () {
      initCollectionFilterMenuA11y();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForCollectionFilterMenu);
  } else {
    waitForCollectionFilterMenu();
  }
})();

//*** CART NOTIFICATION SCREEN READER FOCUS ENTRY ***//
(function () {
  function moveFocusIntoCartNotification() {
    var notification = document.getElementById('cart-notification');
    if (!notification) return;
    if (!notification.classList.contains('active')) return;

    var closeButton = notification.querySelector('.cart-notification__close');
    if (!closeButton) return;

    closeButton.focus();
  }

  function watchCartNotification() {
    var notification = document.getElementById('cart-notification');
    if (!notification) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class' &&
          notification.classList.contains('active')
        ) {
          setTimeout(function () {
            moveFocusIntoCartNotification();
          }, 100);
        }
      });
    });

    observer.observe(notification, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCartNotification);
  } else {
    watchCartNotification();
  }
})();

//*** PREDICTIVE SEARCH REAL FOCUS NAVIGATION ***//
(function () {
  function getSearchInput(container) {
    return container.querySelector('input[type="search"]');
  }

  function getSearchItems(container) {
    return container.querySelectorAll(
      '#predictive-search-results-list a.predictive-search__item, #predictive-search-results-list button.predictive-search__item'
    );
  }

  function neutralizeOptionState(container) {
    var input = getSearchInput(container);
    var resultsList = container.querySelector('#predictive-search-results-list');
    var options = container.querySelectorAll('#predictive-search-results-list li');

    if (input) {
      input.removeAttribute('aria-activedescendant');
    }

    if (resultsList) {
      resultsList.removeAttribute('role');
    }

    options.forEach(function (option) {
      option.removeAttribute('role');
      option.removeAttribute('aria-selected');
    });
  }

  function moveFocusToItem(container, index) {
    var items = getSearchItems(container);
    if (!items.length) return;

    if (index < 0) index = items.length - 1;
    if (index >= items.length) index = 0;

    items[index].focus();
  }

  function setUpPredictiveSearchFocus(container) {
    var input = getSearchInput(container);
    if (!input) return;

    neutralizeOptionState(container);

    container.addEventListener(
      'keydown',
      function (event) {
        var items = getSearchItems(container);
        if (!items.length) return;

        var target = event.target;
        var onInput = target === input;
        var onItem = target.matches('#predictive-search-results-list a.predictive-search__item, #predictive-search-results-list button.predictive-search__item');

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          event.stopPropagation();

          if (onInput) {
            moveFocusToItem(container, 0);
            return;
          }

          if (onItem) {
            var currentIndex = Array.prototype.indexOf.call(items, target);
            moveFocusToItem(container, currentIndex + 1);
          }
        }

        if (event.key === 'ArrowUp') {
          event.preventDefault();
          event.stopPropagation();

          if (onInput) {
            moveFocusToItem(container, items.length - 1);
            return;
          }

          if (onItem) {
            var currentIndex = Array.prototype.indexOf.call(items, target);

            if (currentIndex <= 0) {
              input.focus();
              return;
            }

            moveFocusToItem(container, currentIndex - 1);
          }
        }
      },
      true
    );

    container.addEventListener(
      'input',
      function () {
        setTimeout(function () {
          neutralizeOptionState(container);
        }, 50);
      },
      true
    );

    container.addEventListener(
      'focusin',
      function () {
        neutralizeOptionState(container);
      },
      true
    );
  }

  function initPredictiveSearchA11y() {
    var predictiveSearches = document.querySelectorAll('predictive-search');

    predictiveSearches.forEach(function (container) {
      if (container.__a11yPredictiveSearchFocusInstalled) return;
      container.__a11yPredictiveSearchFocusInstalled = true;
      setUpPredictiveSearchFocus(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPredictiveSearchA11y);
  } else {
    initPredictiveSearchA11y();
  }
})();

//*** SEARCH RESULTS PAGINATION FOCUS ***//
(function () {
  function closeSearchResultsPagePredictiveSearch() {
    var predictiveSearch = document.querySelector('.template-search predictive-search');
    if (!predictiveSearch) return;

    predictiveSearch.removeAttribute('open');
    predictiveSearch.removeAttribute('results');

    var results = predictiveSearch.querySelector('[data-predictive-search]');
    if (results) {
      results.removeAttribute('style');
      results.innerHTML = '';
    }

    var input = predictiveSearch.querySelector('input[type="search"]');
    if (input) {
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }

    if (typeof predictiveSearch.close === 'function') {
      predictiveSearch.close();
    }
  }

  function moveFocusToSearchResultsList() {
    if (window.location.hash !== '#search-results-top') return;

    var target = document.getElementById('search-results-top');
    if (!target) return;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        setTimeout(function () {
          closeSearchResultsPagePredictiveSearch();

          target.setAttribute('tabindex', '-1');
          target.focus();

          target.addEventListener(
            'blur',
            function () {
              target.removeAttribute('tabindex');
            },
            { once: true }
          );
        }, 150);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveFocusToSearchResultsList);
  } else {
    moveFocusToSearchResultsList();
  }

  window.addEventListener('load', function () {
    setTimeout(moveFocusToSearchResultsList, 150);
  });
})();